
import { Component } from "vue-property-decorator";
import { DataTableHeader } from "vuetify";
import { IdentityProvidersModel } from "@flosum-auth/contracts";
import { EntityListView } from "@/modules/shared/classes/entity-list-view";
import AppCheckbox from "@/modules/shared/components/AppCheckbox.vue";
import AppHideText from "@/modules/shared/components/AppHideText.vue";
import AppCopyText from "@/modules/shared/components/AppCopyText.vue";
import IdentityProvidersStatusChip from "./IdentityProvidersStatusChip.vue";

type HeaderKey = keyof Partial<IdentityProvidersModel>;
type Header = DataTableHeader & {
  value: HeaderKey | string;
};

const HEADERS: Header[] = [
  {
    value: "name",
    text: "Name",
    sortable: false,
  },
  {
    value: "active",
    text: "Status",
    sortable: false,
  },
  {
    value: "updatedAt",
    text: "Updated At",
    sortable: false,
  },
  {
    value: "createdAt",
    text: "Created At",
    sortable: false,
  },
];

@Component({
  components: {
    AppCheckbox,
    IdentityProvidersStatusChip,
    AppHideText,
    AppCopyText,
  },
})
export default class IdentityProvidersListView extends EntityListView<Partial<IdentityProvidersModel>> {
  public readonly selectableKey = "id";

  public readonly headers = HEADERS;
}
